import { css } from '@emotion/react'
import { Icon } from '@livechat/design-system-react-components'
import { XApp } from '@livechat/design-system-icons'

import FacebookIcon from 'gatsby-theme-marketplace-base/src/assets/icons/facebook-round.inline.svg'
import LinkedinIcon from 'gatsby-theme-marketplace-base/src/assets/icons/linkedin.inline.svg'
import YoutubeIcon from 'gatsby-theme-marketplace-base/src/assets/icons/youtube.inline.svg'

const iconsCss = (theme) => css`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 1rem;
  line-height: 1.25;

  a {
    color: ${theme.colors.white};
  }

  svg {
    width: 20px;
    height: auto;
  }
`

const Icons = () => {
  return (
    <div css={iconsCss}>
      <a
        aria-label="Go to LiveChat &Xopf; account"
        href={process.env.GATSBY_PRODUCT_TWITTER}
      >
        <Icon source={XApp} size="large" />
      </a>
      <a
        aria-label="Go to LiveChat LinkedIn account"
        href={process.env.GATSBY_PRODUCT_LINKEDIN}
      >
        <LinkedinIcon />
      </a>
      <a
        aria-label="Go to LiveChat Facebook account"
        href={process.env.GATSBY_PRODUCT_FACEBOOK}
      >
        <FacebookIcon />
      </a>
      <a
        aria-label="Go to LiveChat Youtube channel"
        href={process.env.GATSBY_PRODUCT_YOUTUBE}
      >
        <YoutubeIcon />
      </a>
    </div>
  )
}

export default Icons
